<template>
  <div>
    <div class="portlet-title">
      <div class="caption">
        <i class="icon-equalizer font-red-sunglo"></i>
        <span class="caption-subject font-red-sunglo bold uppercase">{{ trans('menu_planner.title') }}</span>
      </div>
    </div>
    <div class="portlet-body form">
      <div class="row">
        <div class="col-sm-2">
          <date-picker
            v-model="menuPlanner.date"
            :time="false"
          />
        </div>
        <div class="col-sm-2">
          <div v-show="brandsLoading" class="glyphicon glyphicon-refresh glyphicon-refresh-animate loading-icon"></div>
          <singleselect
            v-model="menuPlanner.brand"
            :checked="menuPlanner.brand"
            name="brand"
            title="trans('menu_planner.entity.brand')"
            :options="brands"
            @option-selected="getPackages($event.id)"
            @remove="clearPackages()"
          />
        </div>
        <div class="col-sm-2">
          <div v-show="packagesLoading" class="glyphicon glyphicon-refresh glyphicon-refresh-animate loading-icon"></div>
          <singleselect
              v-model="menuPlanner.package"
              :checked="menuPlanner.package"
              name="package"
              title="trans('menu_planner.entity.package')"
              :options="packages"
          />
        </div>
        <div class="col-sm-4">
          <button type="button" class="btn btn-success margin-right-10" @click="showMenu()">
            <span class="glyphicon glyphicon-circle-arrow-right"></span>
            {{ trans('menu_planner.generate') }}
          </button>
          <macronutrient-report
            v-if="menuPlanner.brand"
            :brand="menuPlanner.brand"
            :brands="brands"
          />
        </div>
        <div class="col-sm-2">
          <div class="margin-bottom-5">
            <button
              id="pdf"
              :disabled="!show"
              class="btn btn-success"
              data-loading-text="<i class='fa fa-circle-o-notch fa-spin'></i> Proszę czekać"
              type="button"
              @click="generatePdf()"
            >
              <span class="glyphicon glyphicon-align-justify"></span>
              {{ trans('menu_planner.report_pdf') }}
            </button>
          </div>
          <div>
            <button
              id="pdf_28" type="button"
              class="btn btn-success"
              data-loading-text="<i class='fa fa-circle-o-notch fa-spin'></i> Proszę czekać"
              :disabled="!show"
              @click="generatePdf(28)"
            >
              <span class="glyphicon glyphicon-align-justify"></span>
              {{ trans('menu_planner.report_pdf_28_days') }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="isEditRoute && !isEditViewLoading" class="row">
        <hr>
        <div v-if="showCopyCalendarPicker" class="col-sm-2">
          <date-picker
            v-model="copyFromDate"
            :time="false"
          />
        </div>
        <div v-if="showCopyCalendarPicker" class="col-sm-4">
          <button
              type="button"
              class="btn btn-success"
              :disabled="$store.state.dateDataIsLoading"
              @click="copyMenu()">
            <span class="glyphicon glyphicon-circle-arrow-right"></span>
            {{ trans('menu_planner.copy') }}
          </button>
          <button
              v-if="showCopyMenuButton"
              type="button"
              class="btn btn-success"
              :disabled="$store.state.dateDataIsLoading"
              @click="copyMenuFromNtfy()">
            <span class="glyphicon glyphicon-circle-arrow-right"></span>
            {{ trans('menu_planner.copy_from_ntfy') }}
          </button>
        </div>
        <div class="col-sm-4">
          <button type="button" class="btn btn-success" @click="showCopyCalendar()">
            <span class="glyphicon glyphicon-circle-arrow-right"></span>
            {{
              !showCopyCalendarPicker ? trans('menu_planner.copy_from_day') : trans('menu_planner.hide_copy_from_day')
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datePicker from '../datePicker.vue'
import singleselect from '../singleselect.vue'
import { NTFY_CZ_ID, NTFY_DE_ID, NTFY_ID } from '../../const/common.js'
import MacronutrientReport from '../../js/reports/MacronutrientReport.vue'

export default {
  components: {
    datePicker,
    singleselect,
    MacronutrientReport
  },
  props: {
    date: {
      type: [String, Date],
      default: ''
    },
    brand: {
      type: [String, Number],
      default: ''
    },
    package: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      menuPlanner: {
        date: this.date || moment().locale('pl').format('YYYY-MM-DD'),
        brand: this.brand,
        package: this.package,
      },
      loading: 0,
      progress: 0,
      brands: [],
      packages: [],
      show: false,
      copyFromDate: moment().locale('pl').format('YYYY-MM-DD'),
      showCopyCalendarPicker: false,
      isEditRoute: this.$route.name === 'menu-planner-edit',
      brandsLoading: false,
      packagesLoading: false,
    }
  },
  computed: {
    isValid() {
      return !isNaN(this.menuPlanner.brand) && Boolean(this.menuPlanner.date) !== false
    },
    isEditViewLoading() {
      return this.$store.state.editViewLoading
    },
    showCopyMenuButton() {
      return [NTFY_CZ_ID, NTFY_DE_ID].includes(Number(this.brand))
    },
  },
  watch: {
    'date'(val) {
      this.menuPlanner.date = val
    },
    'brand'(val) {
      this.menuPlanner.brand = val
    },
    'package'(val) {
      this.menuPlanner.package = val
    },
    '$route'(to) {
      this.isEditRoute = to.name === 'menu-planner-edit'
    }
  },
  mounted() {
    this.getBrands()

    if (this.menuPlanner.brand) {
      this.getPackages(this.menuPlanner.brand)
    }
  },
  methods: {
    showMenu() {
      if (this.isValid) {
        this.show = true
        const location = {
          name: 'menu-planner-show',
          params: {
            date: this.menuPlanner.date,
            brand: this.menuPlanner.brand
          }
        }

        if (this.menuPlanner.package) {
          location.query = {
            package: this.menuPlanner.package
          }
        }

        this.$router.push(location)
      }
    },
    copyMenuFromNtfy() {
      this.copyMenu(NTFY_ID)
    },
    copyMenu(fromBrand = null) {
      const data = {
        fromBrandId: parseInt(fromBrand ? fromBrand : this.brand),
        fromDate: this.copyFromDate,
        toBrandId: parseInt(this.brand),
        toDate: this.menuPlanner.date
      }

      this.$store.state.dateDataIsLoading = true
      this.$http.post(Routing.generate('api_post_menu_planner_copy'), data).then(() => {
        if (!window.location.hash.includes('copySuccess=true')) {
          window.open(`${window.location.href}?copySuccess=true`, '_self')
        }
        this.$store.state.dateDataIsLoading = false
      }, (response) => {
        this.handleAjaxError(response)
        this.$store.state.dateDataIsLoading = false
      })
    },
    showCopyCalendar() {
      this.showCopyCalendarPicker = !this.showCopyCalendarPicker
    },
    getBrands() {
      let url = Routing.generate('api_get_brands', { context: 'dropdown' })
      this.loading++
      this.progress++
      this.brandsLoading = true
      this.$http.get(url).then(response => {
        this.brands = response.data
        this.loading--
        this.brandsLoading = false
      }, response => {
        this.handleAjaxError(response)
        this.loading--
        this.brandsLoading = false
      })
    },
    getPackages(brandId) {
      this.clearPackages()
      let url = Routing.generate('api_get_menu_planner_packages', {
        brand: brandId,
        context: 'dropdown'
      })
      this.loading++
      this.progress++
      this.packagesLoading = true
      this.$http.get(url).then(response => {
        this.packages = response.data
        this.loading--
        this.packagesLoading = false
      }, response => {
        this.handleAjaxError(response)
        this.loading--
        this.packagesLoading = false
      })
    },
    clearPackages() {
      this.menuPlanner.package = ''
      this.packages = []
    },
    generatePdf(period = 7) {
      $('#pdf').button('loading')
      let data = {
        brand: this.menuPlanner.brand,
        dateFrom: this.menuPlanner.date,
        period
      }
      $(location).attr('href', Routing.generate('ntfy_admin_app_planmenu_generatepdf', data))
      $('#pdf').button('reset')
    },
    trans(id) {
      return Translator.trans(id)
    },
  },
}
</script>

<style>
.portlet-title {
  border-bottom: 1px solid #eef1f5;
  padding: 0;
  min-height: 48px;
  margin-bottom: 10px;
}

.portlet-title > .caption {
  float: left;
  display: inline-block;
  font-size: 18px;
  line-height: 18px;
  padding: 10px 0;
  font-weight: 400;
}

.portlet-title > .caption > span {
  font-size: 16px;
}

.portlet-title > .caption > i {
  font-size: 15px;
  font-weight: 300;
  margin-top: 3px;
}

.loading-icon {
  position: absolute;
  top: 13px;
  right: 50px;
  z-index: 2;
}
</style>
